import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { MessagesService } from './messages.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'messages',
    templateUrl: './messages.component.html'    
})

export class MessagesComponent implements OnInit {

    messageServiceSubscription: Subscription = new Subscription();

    successMessages: Message[] = [];
    warningMessages: Message[] = [];
    errorMessages: Message[] = [];
    infoMessages: Message[] = [];

    successMessagesSticky: boolean = false;
    warningMessagesSticky: boolean = false;
    errorMessagesSticky: boolean = true;
    infoMessagesSticky: boolean = false;

    successMessagesLife: number = 5000;
    warningMessagesLife: number = 5000;
    errorMessagesLife: number = 5000;
    infoMessagesLife: number = 5000;

    successMessagesLimit: number = 5;
    warningMessagesLimit: number = 5;
    errorMessagesLimit: number = 5;
    infoMessagesLimit: number = 5;

    constructor(private messagesService: MessagesService) {
        this.successMessages = [];
        this.warningMessages = [];
        this.errorMessages = [];
        this.infoMessages = [];
    }

    ngOnInit() {
        this.subscribeToSevice();
        this.successMessages = [];
        this.warningMessages = [];
        this.errorMessages = [];
        this.infoMessages = [];
    }

    subscribeToSevice() {
        this.messageServiceSubscription.add(this.messagesService.addSuccessMessageChange
            .subscribe(message => {
                this.addSuccessMessage(message);
            }));
        this.messageServiceSubscription.add(this.messagesService.addWarningMessageChange
            .subscribe(message => {
                this.addWarningMessage(message);
            }));
        this.messageServiceSubscription.add(this.messagesService.addErrorMessageChange
            .subscribe(message => {
                this.addErrorMessage(message);
            }));
        this.messageServiceSubscription.add(this.messagesService.addInfoMessageChange
            .subscribe(message => {
                this.addInfoMessage(message);
            }));
        this.messageServiceSubscription.add(this.messagesService.addAllSuccessMessagesChange
            .subscribe(messages => {
                this.addAllSuccessMessages(messages);
            }));
        this.messageServiceSubscription.add(this.messagesService.addAllWarningMessagesChange
            .subscribe(messages => {
                this.addAllWarningMessages(messages);
            }));
        this.messageServiceSubscription.add(this.messagesService.addAllErrorMessagesChange
            .subscribe(messages => {
                this.addAllErrorMessages(messages);
            }));
        this.messageServiceSubscription.add(this.messagesService.addAllInfoMessagesChange
            .subscribe(messages => {
                this.addAllInfoMessages(messages);
            }));
    }

    ngOnDestroy() {
        this.messageServiceSubscription.unsubscribe();
    }

    public addSuccessMessage(message: Message) {
        this.successMessages = [];
        if (this.successMessages.length == this.successMessagesLimit) {
            this.successMessages.splice(0, 1);
        }
        this.successMessages.push(message);
    }
    public addWarningMessage(message: Message) {
        if (this.warningMessages.length == this.warningMessagesLimit) {
            this.warningMessages.splice(0, 1);
        }
        this.warningMessages.push(message);
    }
    public addErrorMessage(message: Message) {
        if (this.errorMessages.length == this.errorMessagesLimit) {
            this.errorMessages.splice(0, 1);
        }
        this.errorMessages.push(message);
    }
    public addInfoMessage(message: Message) {
        if (this.infoMessages.length == this.infoMessagesLimit) {
            this.infoMessages.splice(0, 1);
        }
        this.infoMessages.push(message);
    }

    public addAllSuccessMessages(messages: Message[]) {
        messages.forEach(message => {
            this.addSuccessMessage(message);
        });
    }
    public addAllWarningMessages(messages: Message[]) {
        messages.forEach(message => {
            this.addWarningMessage(message);
        });
    }
    public addAllErrorMessages(messages: Message[]) {
        messages.forEach(message => {
            this.addErrorMessage(message);
        });
    }
    public addAllInfoMessages(messages: Message[]) {
        messages.forEach(message => {
            this.addInfoMessage(message);
        });
    }

    /* Not needed due to limiting the message array
    private clearSuccessMessages() {
        this.successMessages = [];
    }
    private clearWarningMessage() {
        this.warningMessages = [];
    }
    private clearErrorMessage() {
        this.errorMessages = [];
    }
    private clearInfoMessage() {
        this.infoMessages = [];
    }
    */
}